<template>
  <transition-group
    name="card-anim"
    class="cards"
    @before-enter="beforeEnter"
    @before-leave="beforeLeave"
    @enter="enter"
    @leave="leave"
    @after-leave="afterLeave"
    tag="div"
    v-bind:css="false"
  >
    <template v-for="(item, index) in this.cards">
      <Card
        v-if="!item.isPromoCard"
        :card="item"
        :backgroundColor="backgroundColor"
        :key="item.id"
        :data-index="index"
        :data-leave-index="cards.length - index"
        :imageFormat="imageFormat"
        :summaryIsHidden="summaryIsHidden"
        :class="{ 'card--summary-is-hidden': summaryIsHidden }"
        :onCardClick="onCardClick"
        @mouseenter.native="selectCard(index)"
        @mouseleave.native="selectCard(-1)"
      />

      <PromoCard
        v-else
        :key="item.id"
        :index="index"
        :promoCard="item"
        :data-index="index"
        :data-leave-index="cards.length - index"
      ></PromoCard>
    </template>
  </transition-group>
</template>

<script>
import settings from '../../filter-settings.js'
import { mapGetters } from 'vuex'
import { CONTENTFUL_IMAGE_FORMAT } from '@/components/_shared/ImageContentful.vue'
import Card from '../Card/Card.vue'
import PromoCard from '@/components/_shared/PromoCard.vue'

export default {
  name: 'Cards',
  components: { Card, PromoCard },
  props: {
    cards: {
      type: Array,
      required: true,
    },

    summaryIsHidden: {
      type: Boolean,
      required: false,
      default: false,
    },

    backgroundColor: {
      type: String,
    },

    imageFormat: {
      type: String,
      default: CONTENTFUL_IMAGE_FORMAT.default,
      validator(value) {
        return Object.values(CONTENTFUL_IMAGE_FORMAT).includes(value)
      },
    },

    onCardClick: {
      type: Function,
      required: false,
      default() {
        return () => {}
      },
    },
  },

  computed: {
    ...mapGetters({
      activeCardVariant: 'nav/activeCardVariant',
    }),
  },

  methods: {
    removeBodyTransitionClass() {
      document.body.classList.remove(settings.transitionClass)
    },

    selectCard(index) {
      this.removeBodyTransitionClass()
      if (On.Store.state.filter !== undefined) this.$store.commit('filter/selectCard', index)
    },

    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(30px)'
    },

    beforeLeave(el) {
      el.style.transition =
        'box-shadow 0.3s ease-in-out, opacity 0.24s ease-in, transform 0.3s ease-in'
    },

    enter(el, done) {
      let delay = el.dataset.index * 40
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0px)'
        done()
      }, delay)
    },

    leave(el, done) {
      const index = Number(el.dataset.leaveIndex)
      // Limit fading out of products to 200ms
      const delay = Math.min(index * 20, 200)

      // Staggered fade out of cards
      setTimeout(() => {
        el.style.opacity = 0
        setTimeout(() => {
          return done()
        }, 300)
      }, delay)
    },

    afterLeave(el) {
      const self = this
      if (On.Store.state.filter !== undefined && el.dataset.index === '0') {
        setTimeout(() => {
          self.$store.commit('filter/switchDisplayedCards')
        }, 100)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cards {
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
}
</style>
